import { Box } from "@mui/material";

const RadioButton = ({ checked, type, onChange }) => {
    const findColor = () => {
        if (type === 'success') {
            return '#00B596';
        } else {
            return '#D14343';
        }
    }
    const handleChange = () => {
        onChange(!checked);
    }
    return (
        <Box border={`${checked ? '5px' : '1px'} solid ${findColor()}`} height='20px' width='20px'
            borderRadius='50%'
            onClick={handleChange}
            sx={{ background: '#fff', cursor: 'pointer' }}>
        </Box>
    )
};

export default RadioButton;